import React, { useEffect } from "react";
import { Card, Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import enGB from "date-fns/locale/en-GB";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { orderdata_saveOrderToSAP } from "reducers/orderdata/orderdata";
import Loader from "components/Loading/Loader";
import FormControlLabel from "@mui/material/FormControlLabel";

import { appdataSelector } from "reducers/appdata/appdata";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { getUser } from "services/auth";
import { calculateCurrentWeek } from "../Schedule/ScheduleHelper";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3
};

function OrderDay(props) {
  console.log("orderday ", props);

  const appdata = useSelector(appdataSelector);
  const order_time_limit = 11;
  const dispatch = useDispatch();
  const weekdays = [...Array(7).keys()].map(i => enGB.localize.day(i));
  const [open, setOpen] = React.useState(false);
  const [allergiesForMenu, setAllergiesForMenu] = React.useState({});
  const [dayDisabled, setDayDisabled] = React.useState(false);
  const [timeLeftToday, setTimeLeftToday] = React.useState(60);
  const [timeNeedsUpdate, setTimeNeedsUpdate] = React.useState(false);
  const [today, setToday] = React.useState(new Date(appdata.serverTime));
  const [orderLocation, setOrderLocation] = React.useState(props.orders && props.orders.BLDG_LOC != "" ? props.orders.BLDG_LOC : getUser()["location"]);
  const [orderMenu, setOrderMenu] = React.useState(
    props.orders && props.orders.MENU1 === "1 " ? "MENU1" :
      props.orders && props.orders.MENU2 === "1 " ? "MENU2" :
        props.orders && props.orders.MENU3 === "1 " ? "MENU3" : undefined
  );

  const dateOfDay = new Date(
    props.date.substring(0, 4) +
    "-" +
    props.date.substring(4, 6) +
    "-" +
    props.date.substring(6, 8)
  );

  useEffect(() => {
    console.log("servertime updated", appdata.serverTime)
    setToday(new Date(appdata.serverTime));
  }, [appdata.serverTime])

  useEffect(() => {
    if (timeNeedsUpdate) {
      updateTimeLeft();
      setTimeNeedsUpdate(false);
    }
  }, [timeNeedsUpdate]);

  useEffect(() => {
    if (props.orders && props.orders.savedToSap) {
      if (orderLocation == "cancel" || orderLocation == "") {
        setOrderLocation(getUser()["location"]);
      }
      if (orderMenu == "cancel") {
        setOrderMenu(undefined);
      }
    }
  }, [props.orders])

  const showTimeLeft = () => {

    if (currentIsHoliday)
      return false;

    if (dayDisabled)
      return false

    if (timeLeftToday >= 60)
      return false

    return true;
  }

  const updateTimeLeft = () => {

    if (!today) {
      setTimeLeftToday(0);
      return;
    }

    console.log("update time left");
    let timeleft = order_time_limit - today.getHours();
    console.log("hours", today.getHours())
    if (timeleft == 1 && (isTomorrow || currentIsDirectlyAfterHoliday)) {
      // (less then) 1 hour left and this day is today
      let t_left = 60 - today.getMinutes();
      if (timeLeftToday != t_left) {
        setTimeLeftToday(t_left);
      }
    } else {
      if (timeLeftToday != 60) setTimeLeftToday(60);
    }
  };

  // check if date is in past
  // check if date is in past
  // check if date is in past
  const dateInFuture = (firstDate, secondDate) => {
    return (
      new Date(firstDate).setHours(0, 0, 0, 0) >
      new Date(secondDate).setHours(0, 0, 0, 0)
    );
  };

  const holidayCheck = (date) => {

    let isHoliday = false;
    let isAfterHoliday = false;

    if (!today) {
      return { isHoliday: isHoliday, isAfterHoliday: isAfterHoliday }
    }


    appdata.holidays.forEach(holiday => {
      //console.log("holiday - start", date, holiday.startDate, holiday.endDate)
      let original = new Date(date).setHours(0, 0, 0, 0);
      let start = new Date(holiday.startDate).setHours(0, 0, 0, 0);
      let end = new Date(holiday.endDate).setHours(0, 0, 0, 0);
      if (original >= start && original <= end) {
        isHoliday = true;
      }
      if (isHoliday) {
        console.log("holiday - is holiday ", date, holiday.startDate, holiday.endDate);
      }
    })






    // check if all dates between tomorrow and the given date are holidays
    // only then mark as after holiday

    let tomorrowDate = new Date();
    tomorrowDate.setDate(today.getDate() + 1);
    tomorrowDate.setHours(0, 0, 0, 0);
    let compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);



    if (!isHoliday && compareDate.getTime() > tomorrowDate.getTime()) {


      let execute = true;
      let count = 0;
      let allHolidaysInBetween = true;

      let checkDate = new Date(tomorrowDate);
      while (execute) {




        if (checkDate.getTime() == compareDate.getTime()) {

          execute = false;
        }
        else {
          let isHoliday = false;

          appdata.holidays.forEach(holiday => {

            let start = new Date(holiday.startDate).setHours(0, 0, 0, 0);
            let end = new Date(holiday.endDate).setHours(0, 0, 0, 0);

            if (checkDate.getTime() >= start && checkDate.getTime() <= end) {
              isHoliday = true;
            }

          })
          // actually check if checkDate is holiday
          // console.log("holidaycheck - checkdate", checkDate.getDay());
          if (isHoliday) {
            //console.log("holiday - checkDate is a holiday ",checkDate)
          }
          else if (checkDate.getDay() != 6 && checkDate.getDay() != 0) {
            console.log("holidaycheck - not", checkDate.getDay());
            allHolidaysInBetween = false;
          }

        }

        let nextDate = new Date(checkDate);

        let addition = 1;
        if (checkDate.getDay() == 6) {
          // saturday
          addition = 2;
        }
        if (checkDate.getDay() == 5) {
          // friday
          addition = 3;
        }
        nextDate.setDate(checkDate.getDate() + addition);
        nextDate.setHours(0, 0, 0, 0);
        checkDate = nextDate;

        count++;
        if (count == 20) {

          execute = false;
        }

      }


      if (allHolidaysInBetween) {
        isAfterHoliday = true;
      }
    }



    //check if the day before the date is a holiday
    let dayBeforeDate = new Date();
    let todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    dayBeforeDate.setDate(date.getDate() - 1);
    dayBeforeDate.setHours(0, 0, 0, 0);
    let yesterdayWasHoliday = false;

    // if the day before the checked date is actually today
    if (dayBeforeDate.getTime() == todayDate.getTime()) {
      // see if today is a holiday
      let istempHoliday = false;
      // loop through the holidays
      appdata.holidays.forEach(holiday => {
        let start = new Date(holiday.startDate).setHours(0, 0, 0, 0);
        let end = new Date(holiday.endDate).setHours(0, 0, 0, 0);
        if (todayDate.getTime() >= start && todayDate.getTime() <= end) {
          istempHoliday = true;
        }
      })
      // if today is a holiday
      // the checkeddate, being after today, is after a holiday
      if (istempHoliday) {
        isAfterHoliday = true;
        yesterdayWasHoliday = true;
      }
    }

    return { isHoliday: isHoliday, isAfterHoliday: isAfterHoliday, yesterdayWasHoliday: yesterdayWasHoliday }
  }


  const dateIsTomorrow = date => {

    if (!today) {
      return false;
    }

    let weekOfDate = calculateCurrentWeek(date);
    let currentWeek = calculateCurrentWeek();

    let tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    if (
      new Date(date).setHours(0, 0, 0, 0) ===
      new Date(tomorrow).setHours(0, 0, 0, 0)

      ||
      // today is friday and the date to check is a monday
      // the day to check is in the the next week
      (date.getDay() == 1 && today.getDay() == 5 && weekOfDate == currentWeek + 1)
    ) {
      return true;
    }

    else { return false };
  };

  const isDateAHoliday = (dateToCheck, holidays) => {
    if (!holidays) return false;
    
    const checkDateNormalized = new Date(dateToCheck).setHours(0, 0, 0, 0);
    
    for (let holiday of holidays) {
      const start = new Date(holiday.startDate).setHours(0, 0, 0, 0);
      const end = new Date(holiday.endDate).setHours(0, 0, 0, 0);
      if (checkDateNormalized >= start && checkDateNormalized <= end) {
        return true;
      }
    }
    return false;
  };

  const weekendOrAfterHolidayClosedFriday = date => {

    if (!today) {
      return false;
    }

    const targetDay = date.getDay();
    let fridayOfPreviousWeek = new Date(date);

    // Check if this is Monday - standard weekend rule
    if (targetDay === 1) {
      fridayOfPreviousWeek.setDate(date.getDate() - 3);
      fridayOfPreviousWeek.setHours(order_time_limit, 0, 0, 0);
      return new Date(today).getTime() >= fridayOfPreviousWeek.getTime();
    }

    // Check if this is Tuesday and Monday is a holiday
    if (targetDay === 2) {
      const mondayOfSameWeek = new Date(date);
      mondayOfSameWeek.setDate(date.getDate() - 1);
      
      if (isDateAHoliday(mondayOfSameWeek, appdata.holidays)) {
        fridayOfPreviousWeek.setDate(date.getDate() - 4);
        fridayOfPreviousWeek.setHours(order_time_limit, 0, 0, 0);
        return new Date(today).getTime() >= fridayOfPreviousWeek.getTime();
      }
    }

    // Check if this is Wednesday and Monday-Tuesday are holidays
    if (targetDay === 3) {
      const mondayOfSameWeek = new Date(date);
      mondayOfSameWeek.setDate(date.getDate() - 2);
      const tuesdayOfSameWeek = new Date(date);
      tuesdayOfSameWeek.setDate(date.getDate() - 1);
      
      if (isDateAHoliday(mondayOfSameWeek, appdata.holidays) &&
          isDateAHoliday(tuesdayOfSameWeek, appdata.holidays)) {
        fridayOfPreviousWeek.setDate(date.getDate() - 5);
        fridayOfPreviousWeek.setHours(order_time_limit, 0, 0, 0);
        return new Date(today).getTime() >= fridayOfPreviousWeek.getTime();
      }
    }

    return false;
  }

  // if the day is a holiday, disable it

  let inFuture = dateInFuture(dateOfDay, today);
  let isTomorrow = dateIsTomorrow(dateOfDay);
  let check = holidayCheck(dateOfDay)
  let currentIsHoliday = check.isHoliday;
  let currentIsDirectlyAfterHoliday = check.isAfterHoliday;
  let yesterdayWasHoliday = check.yesterdayWasHoliday;
  let weekendOrHolidayClosed = weekendOrAfterHolidayClosedFriday(dateOfDay);

  // disable past days (and today)
  if (!inFuture) {
    {
      console.log("orderday, day not in future");
    }
    if (!dayDisabled) setDayDisabled(true);
  } else {
    // disable tomorrow if the time has passed
    let hours = today.getHours();
    let tolate = hours >= order_time_limit ? true : false;
    if (isTomorrow && tolate) {
      // the orderday is tomorrow and the time to order has passed
      console.log("check tomorrow and to late", isTomorrow, tolate)
      if (!dayDisabled) setDayDisabled(true);
    }
    else if (weekendOrHolidayClosed) {
      if (!dayDisabled) setDayDisabled(true);
    }
    else if (currentIsHoliday) {
      if (!dayDisabled) setDayDisabled(true);
    }
    else if (currentIsDirectlyAfterHoliday && (yesterdayWasHoliday || tolate)) {
      if (!dayDisabled) setDayDisabled(true);
    }
    else {
      console.log("check NOT tomorrow or to late", isTomorrow, tolate)
      if (dayDisabled) setDayDisabled(false);
    }
  }

  // set the timeleft for tomorrow
  updateTimeLeft();

  // end check if date is in past
  // end check if date is in past
  // end check if date is in past

  // readable date for display
  // readable date for display
  // readable date for display
  let readableDate =
    props.date.substring(6, 8) +
    "/" +
    props.date.substring(4, 6) +
    "/" +
    props.date.substring(0, 4);

  const handleAllergieClick = params => {
    console.log("allergie clicked", params.allergies, props);
    let allergiesForMenu = [];
    let split = params.allergies.split(",");
    console.log("split", split);
    Object.keys(split).map(key => {
      console.log("key", key);
      allergiesForMenu[split[key]] =
        props.allergies[split[key]]["ALGEN_" + appdata.language];
    });
    setAllergiesForMenu(allergiesForMenu);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const allowLocationDate = () => {
    const cutoffDate = new Date(2024, 5, 19); // Months are 0-indexed, so 5 represents June
    if (dateOfDay < cutoffDate) {
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    console.log("order location or menu updated", orderLocation, orderMenu);

    let orderedMenu = "";
    if (props.orders) {
      orderedMenu = props.orders.MENU3 == "1 " ? "MENU3" : props.orders.MENU2 == "1 " ? "MENU2" : props.orders.MENU1 == "1 " ? "MENU1" : orderedMenu;
    }

    if (!allowLocationDate()) {
      if (!orderLocation) {
        setOrderLocation(1000);
        return;
      }
    }



    if (orderMenu && orderLocation && (!props.orders || (orderMenu != orderedMenu || orderLocation != props.orders.BLDG_LOC))) {
      console.log("should go save");

      let newOrder = {
        MENU1_NUMB: props.menus.MENU1_NUMB,
        MENU2_NUMB: props.menus.MENU2_NUMB,
        MENU3_NUMB: props.menus.MENU3_NUMB
      };
      newOrder.ORDER_DATE = props.date;

      newOrder.MENU1 = "0";
      newOrder.MENU2 = "0";
      newOrder.MENU3 = "0";
      newOrder.BLDG_LOC = "";
      if (orderMenu != "cancel") {
        newOrder[orderMenu] = "1";
        newOrder.BLDG_LOC = orderLocation;
      }

      console.log("new order", newOrder);

      let external = getUser()["isExternal"] ? true : false;
      if (external) {
        newOrder.PROJECT = getUser()["userPrincipalName"];
        newOrder.COMPANY = getUser()["name"]; //Add external User Name as Company Name

        if (props.orders && props.orders.ORDER_NUMB)
          newOrder.ORDER_NUMB = props.orders.ORDER_NUMB;
      }

      dispatch(
        orderdata_saveOrderToSAP({
          weeknumber: props.weeknumber,
          date: props.date,
          values: newOrder,
          group: external
        })
      );
    }
  }, [orderLocation, orderMenu]);

  const handleOrderCancel = () => {
    setOrderLocation("cancel");
    setOrderMenu("cancel");
  }

  const handleOrderLocationUpdate = params => {
    if (params.checked) {
      setOrderLocation(params.value);
    }
    else {
      //setOrderLocation(null);
    }
  }

  const handleOrderMenuUpdate = params => {
    if (params.checked) {
      setOrderMenu(params.selectedMenuKey);
    }
    else {
      setOrderMenu(null);
    }


  };



  let canceled = false;
  if (props.orders && parseInt(props.orders.MENU1) == 0 && parseInt(props.orders.MENU2) == 0 && parseInt(props.orders.MENU3) == 0) {
    canceled = true;
  }

  let kramsachSelected = false;
  let radfeldSelected = false;
  if (props.orders && props.orders.BLDG_LOC == "1200"){
    kramsachSelected = true;
  }
  else if (props.orders && props.orders.BLDG_LOC == "1000"){
    radfeldSelected = true;
  }

  return (
    <React.Fragment>
      <Card className="pb-2">
        <div className="container-fluid no-breadcrumb chapter FormIntegration pt-2 pb-2">
          <Grid container justify="space-between">
            {/* header */}
            {/* header */}
            {/* header */}
            {/* header */}
            <Grid item xs={12}>
              <div className="mt-2 mb-4">
                <b>{weekdays[props.id]}</b> ({readableDate})
                {showTimeLeft() && (
                  <span style={{ color: "red" }}>
                    {" "}
                    Time left: {timeLeftToday} minutes
                  </span>
                )}
                {currentIsHoliday && <span> (holiday)</span>}
              </div>
            </Grid>
            {/* no menus are scheduled for this day */}
            {/* no menus are scheduled for this day */}
            {/* no menus are scheduled for this day */}
            {/* no menus are scheduled for this day */}
            {props.menus === undefined && (
              <Grid>There is no Lunch available for this day</Grid>
            )}
            {/* display menus */}
            {/* display menus */}
            {/* display menus */}
            {/* display menus */}
            {props.menus !== undefined && (
              <Grid
                key={"GRID"}
                item
                xs={12}
                sx={{
                  padding: "10px 20px 10px 0px",
                  border:
                    props.orders && !props.orders.savedToSap
                      ? "2px solid"
                      : "2px solid",
                  borderColor:
                    props.orders && !props.orders.savedToSap
                      ? "info.main"
                      : dayDisabled
                        ? "lightgray"
                        : props.orders != undefined && !canceled
                          ? "primary.light"
                          : "warning.light"
                }}
              >
                {/* show loader when saving */}
                {/* show loader when saving */}
                {/* show loader when saving */}
                {/* show loader when saving */}
                {props.orders && !props.orders.savedToSap && (
                  <div className="ml-2 mr-2 text-center w-100">
                    Saving your order<br></br>
                    <Loader w="50" />
                  </div>
                )}

                {/* show all menus */}
                {/* show all menus */}
                {/* show all menus */}
                {/* show all menus */}
                {((props.orders && props.orders.savedToSap) ||
                  (!props.orders && props.menus)) &&
                  /* loop though menus */
                  /* loop though menus */
                  /* loop though menus */
                  /* loop though menus */
                  Object.keys(props.menus).map(key => {
                    if (
                      key.includes("_NUMB") &&
                      parseInt(props.menus[key]) > 0
                    ) {
                      let menukey = key.substring(0, 5);
                      let selected = false;
                      if (
                        props.orders &&
                        props.orders.hasOwnProperty(menukey) &&
                        parseInt(props.orders[menukey]) > 0
                      ) {
                        selected = true;
                      }

                      return (
                        <div className="" key={"allergymaindiv" + menukey}>
                          {((props.orders && props.orders.savedToSap) ||
                            (!props.orders && props.menus)) && (
                              <div className="ml-2 mr-2 d-inline">
                                <Checkbox
                                  key={"checkbox" + menukey}
                                  disabled={dayDisabled}
                                  checked={selected}
                                  onChange={(event) =>
                                    handleOrderMenuUpdate({
                                      selectedMenuKey: menukey,
                                      checked: event.target.checked,
                                    })
                                  }
                                  inputProps={{ "aria-label": "controlled" }}
                                />
                              </div>
                            )}
                          {
                            props.mappedMenus[parseInt(props.menus[key])][
                            "MENU_" + appdata.language
                            ]
                          }
                          {key == "MENU3_NUMB" && appdata.language == "DE" && " + Salat"}
                          {key == "MENU3_NUMB" && appdata.language == "EN" && " + Salad"}
                          <Link
                            className="ml-1"
                            key={"Link" + menukey}
                            component="button"
                            variant="body2"
                            onClick={() => {
                              handleAllergieClick({
                                allergies:
                                  props.mappedMenus[parseInt(props.menus[key])][
                                  "MENU_ALGEN"
                                  ]
                              });
                            }}
                          >
                            {
                              props.mappedMenus[parseInt(props.menus[key])][
                              "MENU_ALGEN"
                              ]
                            }
                          </Link>
                        </div>
                      );
                    }
                  })


                }

                {/* location selection */}
                {/* location selection */}
                {/* location selection */}
                {/* location selection */}
                {/* location selection */}
                {allowLocationDate() && ((props.orders && props.orders.savedToSap) ||
                  (!props.orders && props.menus)) &&
                  <React.Fragment>
                    <hr></hr>
                    <div className="ml-2 mr-2 d-inline">
                      <FormControlLabel
                        style={{marginLeft: "0px"}}
                        label="Radfeld"
                        control={
                          <Checkbox
                            id="test"
                            key={"checkbox" + "menukey"}
                            disabled={dayDisabled}

                            checked={radfeldSelected}
                            onChange={(event) =>
                              handleOrderLocationUpdate({
                                value: "1000",
                                checked: event.target.checked,
                              })
                            }
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        }
                      
                      />

                    </div>


                    <div className="ml-5 mr-2 d-inline">
                      <FormControlLabel
                        label="Kramsach"
                        control={
                          <Checkbox
                            key={"checkbox" + "menukey"}
                            disabled={dayDisabled}
                            checked={kramsachSelected}
                            onChange={(event) =>
                              handleOrderLocationUpdate({
                                value: "1200",
                                checked: event.target.checked,
                              })
                            }
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        }
                      />

                    </div>
                  </React.Fragment>
                }

                {!dayDisabled && props.orders && !canceled && (
                  <div className="text-right">
                    <Link
                      component="button"
                      variant="body2"
                      onClick={handleOrderCancel}
                      key={"cancel"}
                    >
                      Cancel order
                    </Link>
                  </div>
                )}
              </Grid>
            )}
          </Grid>
        </div>
      </Card>
      <Modal
        key={"modal"}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Allergies for this Menu:
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {Object.keys(allergiesForMenu).map(key => {
              return (
                <div>
                  ({key}) : {allergiesForMenu[key]}
                </div>
              );
            })}
          </Typography>
        </Box>
      </Modal>
    </React.Fragment>
  );

  /* return Object.keys(props.menus).map(key => {
    if(key.includes("_NUMB") && parseInt(props.menus[key]) > 0){
      return <div>available menu: {props.mappedMenus[parseInt(props.menus[key])]["MENU_DE"]}</div>
    }
  }); */
}

export default OrderDay;
